import React, {useState} from 'react';
import {produce} from 'immer';
import carImage from './assets/car-bg.jpg'
import './styles.css'
import {Container, Form, Button, Alert, ListGroup, Accordion, Card, Col, Row} from 'react-bootstrap';


const content = {
    name: "Novelty Driving School",
    tagline: "Learning driving is an investment with lifelong return",
    areas: ["Mississauga", "Oakville", "Burlington", "Etobicoke"],
    features: [
        "Patience, knowledge, and skills to train when you have willingness to learn",
        "Cater to anxious drivers in a calm learning environment",
        "Modern cars with best safety features"
    ],
    services: [
        {
            title: "G1 Licence Training",
            description: "Learn the rules of the road and pass your G1 knowledge test.",
            details: [
                "Obtain your G1 by passing vision and knowledge tests",
                "Practice driving with a fully licensed instructor",
                "Typically 12 months of practice before G2 road test"
            ]
        },
        {
            title: "G2 Exit Road Test Prep",
            description: "Practice driving skills for your G2 road test, including turning, parking, and highway driving.",
            details: [
                "First of two road tests (G2 exit test)",
                "Skills tested: turning, stopping, parallel parking, lane changes, highway driving",
                "Complete after 8–12 months with G1, depending on approved driver education",
                "Provides confidence for solo driving"
            ]
        },
        {
            title: "Full G Licence",
            description: "Complete your G2 and G road tests with confidence, guided by experienced instructors.",
            details: [
                "Final road test after 12 months with G2 licence",
                "Covers advanced driving skills: highway, merging, complex intersections",
                "Successful completion gives full G licence, allowing unrestricted driving",
                "Ongoing guidance for safe driving habits"
            ]
        }
    ]
}

function App() {
    const [formData, setFormData] = useState({name: '', email: '', message: ''});
    const [status, setStatus] = useState({message: '', variant: ''});
    const [submitted, setSubmitted] = useState(false);

    const handleChange = e => {
        const {name, value} = e.target;
        setFormData(produce(draft => {
            draft[name] = value;
        }));
    };

    const handleSubmit = async e => {
        e.preventDefault();
        if (submitted) return;

        setSubmitted(true);
        setStatus({message: '', variant: ''});

        try {
            const response = await fetch('/contact', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setStatus({message: 'Thank you! Your message has been sent.', variant: 'success'});
            } else {
                const data = await response.json();
                setStatus({message: `Error: ${data.error || 'Something went wrong'}`, variant: 'danger'});
                setSubmitted(false);
            }
        } catch (err) {
            setStatus({message: 'Error: Server not reachable', variant: 'danger'});
            setSubmitted(false);
        }
    };

    return (
        <Container fluid style={{
            position: 'relative',
            minHeight: '100vh',
            backgroundImage: `url(${carImage})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        }}>
            <Container className="container-fluid" fluid="md">
                <Row className="py-5">
                    <header className="text-center" style={{
                        background: 'rgba(255, 255, 255, 0.98)',
                        padding: '3rem 2rem',
                        borderRadius: '15px',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
                        borderLeft: '8px solid #198754',
                        borderRight: '8px solid #054fb9'
                    }}>
                        <h1 style={{
                            fontSize: '3.5rem',
                            fontWeight: '800',
                            color: '#054fb9',
                            marginBottom: '1rem',
                            letterSpacing: '1px',
                            textTransform: 'uppercase'
                        }}>{content.name}</h1>
                        <h4 style={{
                            color: '#6c757d',
                            fontWeight: '400',
                            fontSize: '1.3rem',
                            fontStyle: 'italic'
                        }}>{content.tagline}</h4>
                    </header>
                </Row>

                <Row className="py-5">
                    <Col>
                        <Card style={{
                            borderLeft: '6px solid #198754',
                            boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                            borderRadius: '12px',
                            background: 'rgba(255, 255, 255, 0.98)'
                        }} className="p-4">
                            <section>
                                <h2 style={{
                                    color: '#198754',
                                    fontWeight: '700',
                                    marginBottom: '1.5rem',
                                    fontSize: '2rem'
                                }}>About</h2>
                                <p style={{fontSize: '1.05rem', lineHeight: '1.7'}}>
                                    Serving Mississauga, Oakville, Burlington,
                                    Etobicoke and the surrounding areas. Our experienced instructors provide a calm,
                                    patient,
                                    and
                                    professional environment for learning to drive.
                                </p>
                                <p style={{fontSize: '1.05rem', lineHeight: '1.7'}}>With us you will:
                                    <ul style={{marginTop: '1rem'}}>
                                        <li style={{marginBottom: '0.5rem'}}>Learn the rules of the road and pass your G1 knowledge test</li>
                                        <li style={{marginBottom: '0.5rem'}}>Practice driving skills for your G2 road test, including turning, parking,
                                            and highway driving.
                                        </li>
                                        <li style={{marginBottom: '0.5rem'}}>Complete your G2 and G road tests with confidence, guided by experienced
                                            instructors
                                        </li>
                                    </ul>
                                </p>
                            </section>
                        </Card>
                    </Col>
                    <Col>
                        <section className="contact-split">
                            <div>
                                <Card style={{
                                    borderLeft: '6px solid #054fb9',
                                    boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                                    borderRadius: '12px',
                                    background: 'rgba(255, 255, 255, 0.98)'
                                }} className="p-4">
                                    <Card.Body>
                                        {!status.message ? (
                                            <>
                                                <div>
                                                    <h2 style={{
                                                        color: '#054fb9',
                                                        fontWeight: '700',
                                                        marginBottom: '1rem',
                                                        fontSize: '2rem'
                                                    }}>Contact</h2>
                                                    <p style={{fontSize: '1.05rem', color: '#6c757d'}}>Reach out to us and we'll get back to you promptly</p>
                                                </div>
                                                <Form onSubmit={handleSubmit}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label style={{fontWeight: '600'}}>Name</Form.Label>
                                                        <Form.Control type="text" name="name" value={formData.name}
                                                                      onChange={handleChange}
                                                                      style={{borderRadius: '8px', padding: '0.75rem'}}
                                                                      required/>
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label style={{fontWeight: '600'}}>Email</Form.Label>
                                                        <Form.Control type="email" name="email" value={formData.email}
                                                                      onChange={handleChange}
                                                                      style={{borderRadius: '8px', padding: '0.75rem'}}
                                                                      required/>
                                                    </Form.Group>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label style={{fontWeight: '600'}}>Message</Form.Label>
                                                        <Form.Control as="textarea" rows={5} name="message"
                                                                      value={formData.message}
                                                                      style={{borderRadius: '8px', padding: '0.75rem'}}
                                                                      onChange={handleChange} required/>
                                                    </Form.Group>
                                                    <div className="text-center">
                                                        <Button type="submit"
                                                                style={{
                                                                    background: 'linear-gradient(135deg, #198754 0%, #20c997 100%)',
                                                                    border: 'none',
                                                                    fontWeight: '600',
                                                                    padding: '0.75rem 1.5rem',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 4px 15px rgba(25, 135, 84, 0.3)'
                                                                }}
                                                                className="btn-lg"
                                                                disabled={submitted}>
                                                            {submitted ? 'Sending...' : 'Get in Touch 🚗💨'}
                                                        </Button>
                                                    </div>
                                                </Form>
                                            </>
                                        ) : (
                                            <div className="text-center py-5">
                                                {status.variant === 'success' ? (
                                                    <div>
                                                        <h2 style={{
                                                            color: '#198754',
                                                            fontWeight: '700',
                                                            marginBottom: '1.5rem',
                                                            fontSize: '2rem'
                                                        }}>Thank You!</h2>
                                                        <p style={{
                                                            fontSize: '1.2rem',
                                                            color: '#6c757d',
                                                            lineHeight: '1.7'
                                                        }}>Your message has been sent. We'll get back to you promptly.</p>
                                                    </div>
                                                ) : (
                                                    <Alert variant={status.variant} style={{fontSize: '1.1rem'}}>
                                                        {status.message}
                                                    </Alert>
                                                )}
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default App;

